import type { TFunction } from "i18next";

import { AdvisoryManagementResource } from "AdvisoryManagement/Translations/AdvisoryManagementResource";
import { ContractType } from "Infrastructure/Api/Api";

export const getContractTypeOptions = (t: TFunction) => {
	return Object.values(ContractType).map((code) => ({
		code,
		name: t(AdvisoryManagementResource.Enums.ContractType[code]),
	}));
};
